let scrolledOffset = jQuery('header.header').outerHeight() || 0;

function initSkipLink() {
	const skipLink = document.getElementById('wp-skip-link');
	if (!skipLink) {
		return;
	}

	skipLink.setAttribute('tabindex', '0');
}

function openNav() {
	const $header = jQuery('header.header');
	const dialog = document.getElementById('header-nav-menu');
	if (!dialog) {
		return;
	}

	$header.addClass('nav-open');
	$header.find('.nav-toggle').attr('aria-expanded', 'true').attr('aria-label', 'Close navigation');
	dialog.showModal();
	dialog.focus({ preventScroll: true });
}

function closeNav() {
	const $header = jQuery('header.header');
	const dialog = document.getElementById('header-nav-menu');
	$header.removeClass('nav-open');
	$header.find('.nav-toggle').attr('aria-expanded', 'false').attr('aria-label', 'Open navigation');
	dialog.close();
}

function closeLanguageSwitchers() {
	jQuery('.wpml-language-switcher-block--header')
		.removeClass('is-open')
		.find('[data-language-switcher-toggle]')
		.attr('aria-expanded', 'false');
}

export function init() {
	initSkipLink();

	if (jQuery(window).scrollTop() >= scrolledOffset) {
		jQuery('body').addClass('scrolled');
	}

	jQuery(window).on('scroll', function() {
		jQuery('body').toggleClass('scrolled', jQuery(window).scrollTop() >= scrolledOffset);
	});

	jQuery(document).on('click', '.nav-toggle', function() {
		closeLanguageSwitchers();

		if (jQuery('header.header').hasClass('nav-open')) {
			closeNav();
		} else {
			openNav();
		}
	});

	jQuery(document).on('click', '[data-language-switcher-toggle]', function(event) {
		event.preventDefault();
		event.stopPropagation();

		const $switcher = jQuery(this).closest('.wpml-language-switcher-block--header');
		const shouldOpen = !$switcher.hasClass('is-open');

		closeLanguageSwitchers();

		if (shouldOpen) {
			$switcher
				.addClass('is-open')
				.find('[data-language-switcher-toggle]')
				.attr('aria-expanded', 'true');
		}
	});

	jQuery(document).on('click', function(event) {
		if (jQuery(event.target).closest('.wpml-language-switcher-block--header').length) {
			return;
		}

		closeLanguageSwitchers();
	});

	jQuery(document).on('keydown', function(event) {
		if (event.key === 'Escape') {
			closeLanguageSwitchers();
		}
	});

	// Sync nav-open class when dialog is closed natively (Escape key)
	document.getElementById('header-nav-menu').addEventListener('close', function() {
		closeLanguageSwitchers();

		jQuery('header.header').removeClass('nav-open')
			.find('.nav-toggle')
			.attr('aria-expanded', 'false')
			.attr('aria-label', 'Open navigation')
			.trigger('focus');
	});

}
